/** The ordered onboarding checklist. Keys are stable; labels are display text. */
export const ONBOARDING_STEPS = [
    { key: 'sales_rep_info', label: 'Sales Rep Info' },
    { key: 'engage_pmo', label: 'Engage PMO' },
    { key: 'ms_group', label: 'MS Group' },
    { key: 'spam', label: 'SPAM' },
    { key: 'lastpass', label: 'LastPass' },
    { key: 'welcome_email', label: 'Send Welcome Email' },
    { key: 'customer_form', label: 'Customer filled out form' },
    { key: 'create_project', label: 'Create PSA Project' },
    { key: 'create_agreement', label: 'Create PSA Agreement' },
    { key: 'create_cu_project', label: 'Create CU Project' },
];
export const ONBOARDING_STEP_KEYS = ONBOARDING_STEPS.map((s) => s.key);
export const ONBOARDING_STEP_LABELS = ONBOARDING_STEPS.reduce((acc, s) => {
    acc[s.key] = s.label;
    return acc;
}, {});
/** Step keys that map to a "create a PSA record" action button on the onboarding form. */
export const ONBOARDING_AGREEMENT_STEP = 'create_agreement';
export const ONBOARDING_PROJECT_STEP = 'create_project';
/** The "Create CU Project" step creates a ClickUp list from a template. */
export const ONBOARDING_CU_PROJECT_STEP = 'create_cu_project';
export const ONBOARDING_STEP_STATUSES = ['pending', 'completed', 'skipped'];
/**
 * The sections of the public customer welcome form (/w/:token), in display order. Each
 * onboarding record can toggle sections on/off individually (all on by default); the
 * public form only renders — and renumbers — the enabled sections.
 */
export const WELCOME_SECTIONS = [
    { key: 'welcome', label: 'Welcome' },
    { key: 'billing_address', label: 'Billing address' },
    { key: 'billing_contact', label: 'Billing contact' },
    { key: 'project_contacts', label: 'Project contacts' },
    { key: 'support_access', label: 'Dashboard, Tickets & AI Users' },
    { key: 'weekly_reports', label: 'Weekly report recipients' },
    { key: 'cat_plus', label: 'Catalyst+ usage email' },
    { key: 'netsuite', label: 'NetSuite information' },
];
export const WELCOME_SECTION_KEYS = WELCOME_SECTIONS.map((s) => s.key);
export const WELCOME_SECTION_LABELS = WELCOME_SECTIONS.reduce((acc, s) => {
    acc[s.key] = s.label;
    return acc;
}, {});
/**
 * Parses the stored enabled-sections JSON (an array of section keys) into the enabled
 * keys in canonical order. NULL/malformed JSON = every section enabled.
 */
export function parseWelcomeSections(json) {
    if (!json)
        return [...WELCOME_SECTION_KEYS];
    try {
        const parsed = JSON.parse(json);
        if (Array.isArray(parsed)) {
            const enabled = new Set(parsed.filter((x) => typeof x === 'string'));
            const ordered = WELCOME_SECTION_KEYS.filter((key) => enabled.has(key));
            if (ordered.length > 0)
                return ordered;
        }
    }
    catch {
        // Fall through to all-enabled on malformed JSON.
    }
    return [...WELCOME_SECTION_KEYS];
}
export const ONBOARDING_STEP_STATUS_LABELS = {
    pending: 'Pending',
    completed: 'Completed',
    skipped: 'Skipped',
};
export const ONBOARDING_STATUSES = ['in_progress', 'complete'];
export const ONBOARDING_STATUS_LABELS = {
    in_progress: 'In Progress',
    complete: 'Complete',
};
/**
 * Post-onboarding delivery phase (independent of the step checklist). Tracks where a
 * customer sits after the checklist: still being implemented, ready to start billing, or
 * fully live.
 */
export const ONBOARDING_PHASES = [
    'systems_setup',
    'in_implementation',
    'ready_to_bill',
    'live',
];
export const ONBOARDING_PHASE_LABELS = {
    systems_setup: 'Systems Setup',
    in_implementation: 'In Implementation',
    ready_to_bill: 'Ready to Bill',
    live: 'Live',
};
//# sourceMappingURL=onboarding.js.map